export default __webpack_public_path__ + "static/media/planningwork.99b21842.jpg";